import { Container, Row, Col, Tab} from "react-bootstrap";
import { Card } from "./SkillCard";
import TrackVisibility from 'react-on-screen';
import pythoN from "../assets/img/python.png";
import jv from "../assets/img/java.png";
import c from "../assets/img/c.png";
import rust from "../assets/img/rust.png";
import js from "../assets/img/js.png";
import csh from "../assets/img/csh.png";
import ocaml from "../assets/img/ocaml.png";
import react from "../assets/img/react.png";
import sql from "../assets/img/sql.png";
import dj from "../assets/img/dj.png";
import aws from "../assets/img/aws.png";
import cuda from "../assets/img/nvidia.png";

export const Skills = () => {
    const skills = [
      {
        title: "Python",
        description: "Experienced in the Python language and its libraries for a variety of applications, including data analysis, computer vision, and web development.",
        imgUrl: pythoN,
      },
      
      {
        title: "C",
        description: "Proficient in C programming, with experience in systems and low-level development, and HPC - shared and distributed memory parallel programming.",
        imgUrl: c,
      },
      {
        title: "CUDA",
        description: "Experienced in using CUDA for parallel computing and GPU programming.",
        imgUrl: cuda,
      },
      {
        title: "AWS",
        description: "Skilled in using AWS services for cloud computing, storage, deployment, and CloudOps with EC2, S3, Lambda, DynamoDB, and more.",
        imgUrl: aws,
      },
      {
        title: "Java",
        description: "Proficient at developing applications from scratch with Java, such as object-oriented programming and graphics.",
        imgUrl: jv,
      },
      {
        title: "C#",
        description: "Proficient in C# for developing Windows applications, games, and web services.",
        imgUrl: csh,
      },
      {
        title: "Rust",
        description: "Skilled at using Rust to program safe and efficient software.",
        imgUrl: rust,
      },
      {
        title: "OCaml",
        description: "Experienced in functional programming with OCaml.",
        imgUrl: ocaml,
      },
      {
        title: "JavaScript",
        description: "Proficient in building web applications with JavaScript.",
        imgUrl: js,
      },
      {
        title: "React",
        description: "Skilled in building web applications with React.",
        imgUrl: react,
      },
      {
        title: "Django",
        description: "Skilled in building web applications with Django.",
        imgUrl: dj,
      },
      
      {
        title: "SQL",
        description: "Experienced in SQL for database management and data manipulation.",
        imgUrl: sql,
      },
    ];

  return (
     <section className="project" id="skills">
          <Container>
            <Row>
              <Col xs={12}>
                <TrackVisibility>
                  {({ isVisible }) =>
                  <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                    <h2>Skills</h2>
                    <p>Skills and Technologies that I am familar with!</p>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                        <Row className="g-4">
                            {
                                skills.map((exp, index) => {
                                return (
                                    <Card key={index}
                                    {...exp}/>
                                )})
                            }
                        </Row>
                    </Tab.Content>
                  </div>}
                </TrackVisibility>
              </Col>
            </Row>
          </Container>
        </section>
  )
}